import DepartureComment from './DepartureComment';
import departureCommentSchema from './schema';

export { departureCommentSchema };

export default DepartureComment;
